<!-- 创建时间2023/06/15 18:50:08 -->
<!-- 创建人：Zhao bing bing -->
<!-- 组件描述：设置首页 -->
<template>
  <yxt-select v-model="index" :disabled="disabled">
    <yxt-option
      v-for="item in indexList"
      :key="item"
      :label="item"
      :value="item"
    >
    </yxt-option>
  </yxt-select>
</template>

<script>
export default {
  name: 'form-index',
  props: {
    value: {
      type: String,
      default: ''
    },
    content: {
      type: String,
      default: ''
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {};
  },
  computed: {
    index: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit('input', val);
      }
    },
    indexList() {
      let arr = [];
      if (this.content) {
        let list = this.content.replace(/\"/g, '').slice(1, -1).split(',');
        list.forEach(item => {
          if (item.includes('htm') || item.includes('html')) {
            arr.push(item);
          }
        });
      }
      return arr;
    }
  }
};
</script>